export default "__VITE_ASSET__K4eyBRgD__"